import { render, staticRenderFns } from "./viewGateway.vue?vue&type=template&id=56ece192"
import script from "./viewGateway.vue?vue&type=script&lang=js"
export * from "./viewGateway.vue?vue&type=script&lang=js"
import style0 from "./viewGateway.vue?vue&type=style&index=0&id=56ece192&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports